import React from "react";

function Footer() {
  return (
    <>
        <footer className="main-footer">
          Copyright © 2023{" "}
          <strong>
            <a href="https://flashwork.co.th" className="text-warning"> &nbsp;FLASHWORK TEAM CONSULTING CO.,LTD.</a>
          </strong>{" "}
          All rights reserved. Theme by <strong>AdminLTE</strong>
          <div className="float-right  d-sm-inline-block text-sm">
            <b>Version</b> 0.13 - 10/06/2024
          </div>
        </footer>
        <a href="#!" className="scroll-top btn-hover">
          <i className="fa-solid fa-chevron-up fa-bounce fa-xl"></i>
        </a>
        {/* Control Sidebar */}
        <aside className="control-sidebar control-sidebar-dark"></aside>
    </>
  );
}

export default Footer;
